// @mui
import Container from '@mui/material/Container';
// hooks
// _mock
// components
import { useSettingsContext } from 'src/components/settings';
import TechnicalUserTable from './technical-table';
// assets
//

// ----------------------------------------------------------------------

export default function TechnicalAdmin() {
    // const { user } = useMockedUser();
    const settings = useSettingsContext();
    return (
        <Container maxWidth={ settings.themeStretch ? false : 'xl' }>
            <TechnicalUserTable />
        </Container >
    );
}
